import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { CommonModule } from 'src/common/common.module';
import { ImgHandleErrorDirective } from 'src/common/media/img.directive';
import { IconLink, MenuConfiguration } from 'src/common/models';
import { ContentCacheUtils } from 'src/utils/storage.util';
type IconLinkStringed = Omit<IconLink, 'icon'> & { icon: string }
@Component({
  selector: 'app-social-links',
  imports: [CommonModule, ImgHandleErrorDirective],
  templateUrl: './social-links.component.html',
  styleUrl: './social-links.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialLinksComponent {
  menu = signal(ContentCacheUtils.menu<MenuConfiguration>());
  socials = computed<IconLinkStringed[] | undefined>(() => {
    let menu = this.menu();
    return menu?.socials?.map(s => {
      if (typeof s.icon != 'string')
        s.icon = s.icon?.imageUrl
      return s as IconLinkStringed
    })
  })
}
